<template>
    <div class="select3" v-click-outside="onClickOutside">
        <div :class="['select3-button', isActive ? 'active' : '', disabled ? 'disabled-element' : '']" @click="() => {disabled ? false : showed = !showed, fetch()}">
            <div :class="'select3-button-text'">{{ title }} <span v-if="selectedIds.length >= 1">:</span></div>
            <div v-if="selectedIds.length >= 1" class="select3-button-count">{{ selectedIds.length }}</div>
            <div class="select3-button-arrow"><i class="icon-arrow-down22"></i></div>
        </div>
        <div class="select-menu" v-if="showed">
            <div class="select-menu-search">
                <input type="text" v-model="search" placeholder="Пошук"/>
                <i class="icon-search4"></i>
            </div>
            <div class="select-menu-options">
                <div class="select-menu-option" v-for="option in options">
                    <CheckBox
                        :modelValue="false"
                        @update:modelValue="newValue => selectValue(option.key, newValue, options)"
                    />
                    <span>{{ option.value }}</span>
                </div>
                <div class="select-menu-option" v-for="option in selectedOptions">
                    <CheckBox
                        :modelValue="selectedIds.includes(option.key)"
                        @update:modelValue="newValue => selectValue(option.key, newValue, selectedOptions)"
                    />
                    <span>{{ option.value }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { httpClient } from '../../../../services/HttpClient';
import CheckBox from "../../../new/form/checkbox/AppCheckbox.vue";
import vClickOutside from 'click-outside-vue3'

export default {
    name: "MultiAutocompleteComponent",
    components: {
        CheckBox
    },
    props: {
        modelValue: {
            type: Array,
            default() {
                return []
            }
        },
        urlProps: {
            type: String,
            default: '/catalog/product-items/autocomplete',
        },
        title: {
            type: String,
            default: () => translate('components.input.placeholder')
        },
        minLength: {
            type: Number,
            default: 3
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            search: '',
            showed: false,
            options: [],
            selectedOptions : [],
            selectedIds: this.modelValue
        }
    },
    methods: {
        onClickOutside() {
            this.showed = false;
            this.search = '';
            this.options = [];
        },
        fetch() {
            httpClient.get(this.urlProps, {
                search: this.search,
                ignore_ids: this.selectedIds,
                limit: this.limit
            }).then((response) => {

            this.selectedOptions = response.data.meta.ignored.map(element => {
                return {
                    key: element.id,
                    value: element.label,
                }
            });

            this.options = response.data.data.map(element => {
                return {
                    key: element.id,
                    value: element.label,
                }
            });
            })
        },
        selectValue(identifier, checked, options) {
            if (checked) {
                this.selectedIds.push(identifier)
            } else {
                this.selectedOptions = this.selectedOptions.filter(item => item.key !== identifier);
                this.selectedIds = this.selectedIds.filter(selectedId => selectedId !== identifier);
            }
            this.$emit('update:modelValue', this.selectedIds)
            this.fetch()
        }
    },
    computed: {
        isActive() {
            return this.selectedIds.length > 0
        },
    },
    watch: {
        search(newValue) {
            if (newValue.length >= this.minLength) {
                this.fetch();
            }
        }
    },
    mounted() {
        this.fetch()
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
}
</script>
<style scoped>
.select3 {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -o-user-select: none;
    user-select: none;
    position: relative;
}
.select3-button {
    display: flex;
    column-gap: 10px;
    padding: 0 10px;
    background: #f5f5f5;
    height: 34px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;
    justify-content: space-between;
}
.select3-button-text, .select3-button-arrow {
    line-height: 34px;
}

.select3-button-text-disabled {
    line-height: 34px;
    color: #999;
}

.select-menu {
    background: #ffffff;
    position: absolute;
    z-index: 10;
    margin-top: 10px;
    box-shadow: 0 4px 8px -2px #091e4240, 0 0 1px #091e424f;
    border-radius: 2px;
    min-width: 100%;
}

.select-menu-search {
    height: 40px;
    display: flex;
    border-bottom: solid 1px #dfe1e6;
    justify-content: space-between;
    padding: 0 10px;
}

.select-menu-search input{
    margin: unset;
    padding: unset;
    border: unset;
    width: 200px;
}

.select-menu-search input:focus {
    outline: none;
}

.select-menu-search i{
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    margin: 10px 0;
}

.select-menu-options {
    padding: 5px 0;
    max-height: 250px;
    overflow-y: auto;
    white-space: nowrap;
}

.select-menu-option {
    display: flex;
    padding: 8px 10px;
    column-gap: 10px;
    transition: background 0.3s;
}

.select-menu-option:hover {
    background: #eaeaea;
    cursor: pointer;
}
.select3-button-count {
    background: #3f51b5;
    color: white;
    line-height: 16px;
    height: 16px;
    padding: 0 5px;
    margin: 9px 0;
    font-size: 10px;
    border-radius: 2px;
}
</style>